import { ComponentType, FC, FocusEvent, useCallback } from 'react';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import { useField } from 'formik';

type BaseProps = Omit<TextFieldProps, 'value' | 'onChange'>;

type Props = BaseProps & {
  name: string;
  component?: ComponentType<BaseProps>;
};

const TextField: FC<Props> = props => {
  const { name, component, helperText, onBlur, ...rest } = props;
  const [field, meta] = useField<string>(name);

  const Component = component ? component : MuiTextField;

  const handleBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      field.onBlur(event);
      onBlur && onBlur(event);
    },
    [field, onBlur]
  );

  return (
    <Component
      variant="standard"
      {...rest}
      {...field}
      name={name}
      onBlur={handleBlur}
      error={Boolean(meta.touched && meta.error)}
      helperText={(meta.touched && meta.error) || helperText}
    />
  );
};

export default TextField;
